import { createSelector } from "@reduxjs/toolkit";

export const singleClientEvidenceState = (state) => state.singleClientEvidence;

export const singleClientEvidenceSelector = createSelector(singleClientEvidenceState, (state) => state);
